import { useEffect, useState } from "react";

const QUOTES = [
    {
        text: "Leur outil est intuitif et donne une estimation instantanée.",
        logo: "/logos/kandbaz.svg",
        alt: "KANDBAZ",
        author: "Christophe Godeau et Jérôme Winterholer, dirigeants de KANDBAZ",
    },
    {
        text: "Ils ont analysé mes frais et trouvé des solutions concrètes pour les réduire de façon significative.",
        logo: "/logos/investance-partners.png",
        alt: "Investance Partners",
        author: "Benoit Le Belzic, INVESTANCE PARTNERS",
    },
    {
        text: "Ce qui m’a particulièrement marqué, c’est leur envie de challenger les solutions existantes afin de rechercher les meilleures conditions […] pour leurs clients.",
        logo: "/logos/mconstructions.png",
        alt: "M’CONSTRUCTIONS",
        author: "Nina Blanchard, Dirigeante de M’CONSTRUCTIONS",
        logoClass: "h-10",
    },
];

export const TrustQuotes = () => {
    const [idx, setIdx] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (paused) return undefined;
        const t = setInterval(() => setIdx((i) => (i + 1) % QUOTES.length), 6000);
        return () => clearInterval(t);
    }, [paused]);

    return (
        <figure
            data-testid="sim-trust-quotes"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            className="m-0 bg-white border border-border-default rounded-xl p-5 flex flex-col gap-3"
        >
            <div className="grid">
                {QUOTES.map((q, i) => (
                    <div
                        key={q.alt}
                        data-testid={`sim-trust-quote-${i}`}
                        aria-hidden={i !== idx}
                        className={`[grid-area:1/1] flex flex-col gap-3 transition-[opacity,transform] duration-500 ${i === idx ? "opacity-100 translate-y-0" : "opacity-0 translate-y-1 pointer-events-none"}`}
                    >
                        <blockquote className="m-0 text-base leading-normal text-navy">« {q.text} »</blockquote>
                        <img src={q.logo} alt={q.alt} loading="lazy" className={`${q.logoClass || "h-6"} w-auto self-start object-contain`} />
                        <figcaption className="text-[13px] leading-normal text-grey-text-soft">{q.author}</figcaption>
                    </div>
                ))}
            </div>
            <div className="flex gap-1 -ml-2.5 -mb-2" role="tablist" aria-label="Témoignages">
                {QUOTES.map((q, i) => (
                    <button
                        key={q.alt}
                        type="button"
                        role="tab"
                        aria-selected={i === idx}
                        aria-label={`Témoignage ${i + 1}`}
                        data-testid={`sim-trust-dot-${i}`}
                        onClick={() => setIdx(i)}
                        className="w-11 h-11 md:w-8 md:h-8 flex items-center justify-center"
                    >
                        <span className={`block h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === idx ? "w-6 bg-navy" : "w-1.5 bg-border-strong"}`} />
                    </button>
                ))}
            </div>
        </figure>
    );
};
